import { render, staticRenderFns } from "./OutPremiumReports.vue?vue&type=template&id=b2e5449c&"
import script from "./OutPremiumReports.vue?vue&type=script&lang=js&"
export * from "./OutPremiumReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports